<template>
    <nav class="navbar navbar-map navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand" href="/">
            <img :src="host.media.logo.sizes['256']" alt="logo" style="max-height: 34px;">
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item nav-item-map">
                    <a class="nav-link" href="#" @click="showZone()"><i class="fas fa-map-marker"></i> Mostra Zone</a>
                </li>
                <li class="nav-item nav-item-map">
                    <a class="nav-link" href="#" @click="showSearchAddress()"><i class="fas fa-map-marked"></i> Ricerca Per Indirizzo</a>
                </li>
                <li class="nav-item nav-item-map">
                    <a class="nav-link" href="#" @click="eraseEvent()"><i class="fas fa-eraser"></i> Pulisci Mappa</a>
                </li>
            </ul>

            <form class="form-inline my-2 my-lg-0">
                <button class="btn btn-outline-primary my-2 my-sm-0" @click="closeEvent()" type="button">Chiudi Mappa</button>
            </form>
        </div>
    </nav>
</template>

<script>
    export default {
        name: 'SideBar',
        props: ['event', 'zonestatus', 'opened', 'modestatus', 'sidelock', 'host'],
        methods: {
            showZone() {
                this.$emit('showzone');
            },
            showPins() {
                this.$emit('showpins');
            },
            showSearchAddress() {
                this.$emit('showaddress');
            },
            closeEvent() {
                this.$emit('closemap')
            },
            eraseEvent() {
                this.$emit('erasemap');
            },
            requestCloseOpenEvent() {
                this.$emit('openSideBar');
            },
            switchDarkMode() {
                this.$emit('darkmode');
            },
            lockSideBar() {
                this.$emit('locksidebar');
            },
            drawPolygon() {
                this.$emit('drawpolygon')
            }
        },
        watch: {
            opened: function(newVal, oldVal) { // watch it
                this.show = newVal;
            }
        },
        mounted() {},
        data() {
            return {
                show: this.opened
            }
        }

    }
</script>

<style lang="scss">
    @import './Styles/sidebar.css';
</style>